module.exports = __webpack_public_path__ + "static/fonts/ionicons.2c2ae06.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/fonts/ionicons.eot?v=2.0.0
// module id = j78j
// module chunks = 34